import type { UtmSource } from '../types/utm-source';

function createUtmParams(
  params: Record<string, string | null>,
): UtmSource | null {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== null),
  ) as UtmSource;

  return Object.keys(filteredParams).length > 0 ? filteredParams : null;
}

export function getUtmParams(): UtmSource | null {
  const searchParams = new URLSearchParams(window.location.search);
  const utmSource = searchParams.get('utm_source');
  const utmMedium = searchParams.get('utm_medium');
  const utmCampaign = searchParams.get('utm_campaign');
  const utmId = searchParams.get('utm_id');
  const utmCampaignId = searchParams.get('utm_campaign_id');
  const utmTerm = searchParams.get('utm_term');
  const utmAdset = searchParams.get('utm_adset');
  const utmContent = searchParams.get('utm_content');
  const utmAdname = searchParams.get('utm_adname');

  const urlUtmParams = createUtmParams({
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    utm_id: utmId ?? utmCampaignId,
    utm_term: utmTerm ?? utmAdset,
    utm_content: utmContent ?? utmAdname,
  });

  if (urlUtmParams !== null) {
    Object.entries(urlUtmParams).forEach(([key, value]) => {
      if (value !== undefined) {
        localStorage.setItem(`gb_${key}`, value);
      }
    });
    return urlUtmParams;
  }

  return createUtmParams({
    utm_source: localStorage.getItem('gb_utm_source'),
    utm_medium: localStorage.getItem('gb_utm_medium'),
    utm_campaign: localStorage.getItem('gb_utm_campaign'),
    utm_id: localStorage.getItem('gb_utm_id'),
    utm_term: localStorage.getItem('gb_utm_term'),
    utm_content: localStorage.getItem('gb_utm_content'),
  });
}
